import { useEffect } from 'react';
import useAnalytics from './useAnalytics';
export default function useAnalyticsListener() {
  const {
    actualHandlers: {
      sendClick,
      sendDomReadyEvent,
      sendEvent,
      sendImpressions,
      sendPage,
      sendThirdPartyEvent
    }
  } = useAnalytics();
  useEffect(() => {
    window.caiEventBus.on('analytics:sendClick', _ref => {
      let {
        type,
        event,
        data
      } = _ref;
      sendClick(type, event, data);
    });
    window.caiEventBus.on('analytics:sendDomReadyEvent', event => {
      sendDomReadyEvent(event);
    });
    window.caiEventBus.on('analytics:sendEvent', event => {
      sendEvent(event);
    });
    window.caiEventBus.on('analytics:sendImpressions', event => {
      sendImpressions(event);
    });
    window.caiEventBus.on('analytics:sendPage', event => {
      sendPage(event);
    });
    window.caiEventBus.on('analytics:sendThirdPartyEvent', event => {
      sendThirdPartyEvent(event);
    });
    return () => {
      window.caiEventBus.off('analytics:sendClick');
      window.caiEventBus.off('analytics:sendDomReadyEvent');
      window.caiEventBus.off('analytics:sendEvent');
      window.caiEventBus.off('analytics:sendImpressions');
      window.caiEventBus.off('analytics:sendPage');
      window.caiEventBus.off('analytics:sendThirdPartyEvent');
    };
  }, [sendClick, sendDomReadyEvent, sendEvent, sendImpressions, sendPage, sendThirdPartyEvent]);
}